<template>
  <div :class="{ 'p-p-3': $route.name == 'AddServiceCalls' }">
    <div>
      <local-all-services
        v-if="showGroups"
        :services="GroupsOptions"
        @groupSelected="groupSelected"
      ></local-all-services>
      <div v-else>
        <div class="service-call-fields">
          <div class="p-d-flex p-flex-column" v-if="!isEdit">
            <span>{{ __("Building") }}:</span>
            <p-vue-dropdown
              :options="BuildingsOptions"
              :optionLabel="'BuildName'"
              :optionValue="BID"
              :filter="BuildingsOptions.length > 10"
              v-model="serviceCallLocal.BIDValue"
              class="dropdown"
              @change="buildingChanged"
              :disabled="isEditSmsContent"
            >
              <template #value="{ value, placeholder}">
                <div class="inner p-d-flex p-jc-between">
                  <span class="value">{{
                    value ? value.BuildName : placeholder
                  }}</span>
                  <span class="icon">
                    <i-icon name="arrow" />
                  </span>
                </div>
              </template>
            </p-vue-dropdown>
            <i-form-error :data="errors.BID" />
          </div>
          <div class="p-mt-2">
            <span>{{ __("Subject") }}:</span>
            <p-vue-textarea
              :autoResize="true"
              rows="4"
              class="p-inputtext--alt"
              v-model="serviceCallLocal.Subject"
              :disabled="isEditSmsContent"
            />
            <i-form-error :data="errors.Subject" />
          </div>
          <div class="p-mt-2">
            <span>{{ __("Remarks") }}:</span>
            <p-vue-textarea
              :autoResize="true"
              rows="4"
              class="p-inputtext--alt"
              v-model="serviceCallLocal.Desc"
              :disabled="isEditSmsContent"
            />
          </div>
          <div class="p-d-flex p-flex-column" v-if="isEdit">
            <span>{{ __("Unit") }}:</span>
            <p-vue-dropdown
              :options="UnitsOptions"
              :optionLabel="'Number'"
              :optionValue="UID"
              :filter="UnitsOptions.length > 10"
              v-model="serviceCallLocal.UIDValue"
              class="dropdown"
            >
              <template #value="{ value, placeholder}">
                <div class="inner p-d-flex p-jc-between">
                  <span class="value">{{
                    value ? value.Number : placeholder
                  }}</span>
                  <span class="icon">
                    <i-icon name="arrow" />
                  </span>
                </div>
              </template>
            </p-vue-dropdown>
          </div>
          <div class="grid">
            <div class="p-d-flex p-flex-column p-mt-2">
              <span>{{ __("Type") }}:</span>
              <p-vue-dropdown
                :options="ReportTypesOptions"
                :optionLabel="'ReportType'"
                :optionValue="Num"
                :filter="ReportTypesOptions.length > 10"
                v-model="serviceCallLocal.ReportTypeValue"
                class="dropdown"
              >
                <template #value="{ value, placeholder}">
                  <div class="inner p-d-flex p-jc-between">
                    <span class="value">{{
                      value ? value.ReportType : placeholder
                    }}</span>
                    <span class="icon">
                      <i-icon name="arrow" />
                    </span>
                  </div>
                </template>
              </p-vue-dropdown>
            </div>
            <div class="p-d-flex p-flex-column p-mt-2" v-if="isEdit || fastAdd">
              <span>{{ __("Group") }}:</span>
              <p-vue-dropdown
                :options="GroupsOptions"
                :optionLabel="'GroupName'"
                :optionValue="GroupID"
                :filter="GroupsOptions.length > 10"
                v-model="serviceCallLocal.mtcGroupIDValue"
                class="dropdown"
              >
                <template #value="{ value, placeholder}">
                  <div class="inner p-d-flex p-jc-between">
                    <span class="value">{{
                      value ? value.GroupName : placeholder
                    }}</span>
                    <span class="icon">
                      <i-icon name="arrow" />
                    </span>
                  </div>
                </template>
              </p-vue-dropdown>
            </div>
            <div class="p-d-flex p-flex-column p-mt-2">
              <span>{{ __("User") }}:</span>
              <p-vue-dropdown
                :options="WorkersOptions"
                :optionLabel="'WorkerName'"
                :optionValue="Num"
                :filter="WorkersOptions.length > 10"
                v-model="serviceCallLocal.WorkerNumValue"
                class="dropdown"
              >
                <template #value="{ value, placeholder}">
                  <div class="inner p-d-flex p-jc-between">
                    <span class="value">{{
                      value ? value.WorkerName : placeholder
                    }}</span>
                    <span class="icon">
                      <i-icon name="arrow" />
                    </span>
                  </div>
                </template>
              </p-vue-dropdown>
            </div>
            <div class="p-d-flex p-flex-column p-mt-2">
              <span>{{ __("Priority") }}:</span>
              <p-vue-dropdown
                :options="PriorityOptions"
                :optionLabel="'ReportPriority'"
                :optionValue="Num"
                :filter="PriorityOptions.length > 10"
                v-model="serviceCallLocal.ReportPriorityValue"
                class="dropdown"
              >
                <template #value="{ value, placeholder}">
                  <div class="inner p-d-flex p-jc-between">
                    <span class="value">{{
                      value ? value.ReportPriority : placeholder
                    }}</span>
                    <span class="icon">
                      <i-icon name="arrow" />
                    </span>
                  </div>
                </template>
              </p-vue-dropdown>
            </div>
            <div
              v-if="!isEdit && !fastAdd && !showAddContactDropdowns"
              class="p-d-flex p-ai-center p-jc-end p-flex-column"
            >
              <p-vue-button
                class="button p-button-rounded p-button-success add-contact"
                :label="__('Add Reporter')"
                @click="addContact"
                :disabled="isEditSmsContent"
              />
              <i-form-error :data="errors.addContact" />
            </div>
          </div>
          <div v-if="showAddContactDropdowns" class="p-mt-2">
            <div class="p-d-flex p-flex-column">
              <span>{{ __("Unit") }}:</span>
              <p-vue-dropdown
                :options="UnitsOptions"
                :optionLabel="'Number'"
                :optionValue="UID"
                :filter="UnitsOptions.length > 10"
                v-model="serviceCallLocal.UIDValue"
                class="dropdown"
                :disabled="isEditSmsContent"
                @change="UnitSelected"
              >
                <template #value="{ value, placeholder}">
                  <div class="inner p-d-flex p-jc-between">
                    <span class="value">{{
                      value ? value.Number : placeholder
                    }}</span>
                    <span class="icon">
                      <i-icon name="arrow" />
                    </span>
                  </div>
                </template>
              </p-vue-dropdown>
            </div>
            <div class="p-d-flex p-flex-column p-mt-2">
              <span>{{ __("Reporter") }}:</span>
              <p-vue-dropdown
                :options="serviceCallLocal.UIDValue?.contacts"
                :optionLabel="'ContactName'"
                :optionValue="ContactID"
                :filter="serviceCallLocal.UIDValue?.contacts.length > 10"
                v-model="serviceCallLocal.Contact"
                @change="changeReporter"
                class="dropdown"
                :disabled="isEditSmsContent"
              >
                <template #value="{ value, placeholder}">
                  <div class="inner p-d-flex p-jc-between">
                    <span class="value">{{
                      value ? value.ContactName : placeholder
                    }}</span>
                    <span class="icon">
                      <i-icon name="arrow" />
                    </span>
                  </div>
                </template>
              </p-vue-dropdown>
            </div>
          </div>
          <div class="grid p-mt-2" v-if="!isEdit">
            <div class="p-d-flex p-flex-column">
              <span>{{ __("Due Date") }}:</span>
              <p-vue-calendar
                type="text"
                id="calendar"
                class="p-inputtext--alt no-radius"
                v-model="serviceCallLocal.DueDate"
              />
            </div>
            <div class="p-d-flex p-ai-center">
              <span>{{ __("Has been treated") }}:</span>
              <p-vue-checkbox
                class="p-mx-2"
                :binary="true"
                v-model="isTreatment"
                @change="isTreatmentChange"
              />
            </div>
          </div>
          <div class="grid supplier p-mt-2">
            <div class="p-d-flex p-flex-column">
              <span>{{ __("Supplier") }}:</span>
              <p-vue-dropdown
                :options="SuppliersOptions"
                :optionLabel="'NameSupplier'"
                :optionValue="pid"
                :filter="SuppliersOptions.length > 10"
                v-model="serviceCallLocal.SupplierNumValue"
                class="dropdown"
              >
                <template #value="{ value, placeholder}">
                  <div class="inner p-d-flex p-jc-between">
                    <span class="value">{{
                      value ? value.NameSupplier : placeholder
                    }}</span>
                    <span class="icon">
                      <i-icon name="arrow" />
                    </span>
                  </div>
                </template>
              </p-vue-dropdown>
            </div>
            <div class="p-d-flex p-jc-center p-ai-end p-mb-1">
              <p-vue-button
                icon="pi pi-external-link"
                class="p-button-rounded p-button-success p-button-outlined show-supplier"
                @click="showSupplier"
                :disabled="!serviceCallLocal.SupplierNumValue"
              />
            </div>
          </div>
          <div v-if="!isEdit">
            <div class="p-d-flex p-ai-center p-jc-between p-my-2">
              <div class="p-d-flex p-ai-center">
                <span>{{ __("SMS to supplier") }}:</span>
                <p-vue-checkbox
                  class="p-mr-1"
                  :binary="true"
                  v-model="smsSentToSupplier"
                  @change="changeSmsSentToSupplier"
                  :disabled="!serviceCallLocal.SupplierNumValue"
                />
              </div>
            </div>
            <span v-if="smsSentToSupplier && serviceCallLocal.SupplierNumValue"
              >{{ __("Sms message to supplier") }}:</span
            >
            <p-vue-textarea
              v-if="smsSentToSupplier && serviceCallLocal.SupplierNumValue"
              :autoResize="true"
              rows="4"
              class="p-inputtext--alt"
              v-model="contentSMSToSupplier"
              @input="lockAllFields"
            />
          </div>
          <div v-else>
            <div class="grid p-mt-2">
              <div class="p-d-flex p-flex-column">
                <span>{{ __("Reporter Name") }}:</span>
                <p-vue-input-text v-model="serviceCallLocal.ReportName" />
              </div>
              <div class="p-d-flex p-flex-column">
                <span>{{ __("Phone") }}:</span>
                <p-vue-input-text v-model="serviceCallLocal.ReturnPhone" />
              </div>
            </div>
            <div class="p-d-flex p-flex-column p-mt-2">
              <span>{{ __("Email") }}:</span>
              <p-vue-input-text v-model="serviceCallLocal.ReturnEmail" />
            </div>
            <div class="grid">
              <div class="p-d-flex p-flex-column p-mt-2">
                <span>{{ __("Due Date") }}:</span>
                <p-vue-calendar
                  type="text"
                  id="calendar"
                  class="p-inputtext--alt no-radius"
                  v-model="serviceCallLocal.DueDate"
                />
              </div>
              <div class="p-d-flex p-flex-column p-mt-2">
                <span>{{ __("Closing date") }}:</span>
                <p-vue-calendar
                  type="text"
                  id="calendar"
                  class="p-inputtext--alt no-radius"
                  v-model="serviceCallLocal.ClosingDate"
                />
              </div>
            </div>
          </div>
        </div>
        <add-pic class="upload-button p-mt-4" @click="addImage">
          <span
            class="p-button-icon p-button-icon-left pi pi-fw pi-plus"
          ></span>
          {{ __("Add an image") }}
        </add-pic>
        <p-vue-file-upload
          url="./"
          accept="image/*"
          class="upload-button"
          style="display: none;"
          :multiple="false"
          :customUpload="true"
          :showCancelButton="false"
          :showUploadButton="false"
          :chooseLabel="__('Add an image')"
          :invalidFileLimitMessage="
            __('Maximum number of files exceeded, limit is {0} at most.')
          "
          :invalidFileSizeMessage="
            __('{0}: Invalid file size, file size should be smaller than {1}.')
          "
          v-model="attachments"
          @clear="clearAttachments"
          @select="selectAttachment"
          ref="Upload"
        />

        <div class="upload-preview">
          <ul>
            <li v-for="(file, index) in attachments" :key="index">
              <!-- <img :src="getSrc(file)" /> -->
              <img :src="file" />
              <p-vue-button
                class="p-button-danger p-button-sm p-button-rounded"
                @click.prevent="doTrashAttachment(index)"
              >
                <i-icon name="trash" />
              </p-vue-button>
            </li>
          </ul>
        </div>
        <div class="p-d-flex p-jc-between p-mt-4">
          <p-vue-button
            class="button p-button-rounded p-button-success"
            :label="__('Save')"
            @click="save"
          />
          <p-vue-button
            class="button p-button-rounded p-button-success"
            :label="__('Cancel')"
            @click="cancel"
          />
        </div>
      </div>
    </div>
  </div>

  <i-override-dialog
    v-model:visible="isShowSupplier"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="__('Supplier')"
  >
    <div>
      <local-supplier
        :supplierIDToShow="this.serviceCallLocal.SupplierNumValue?.pid"
      ></local-supplier>
      <!-- <p-vue-button
        class="p-button-secondary p-button-rounded p-d-flex p-m-auto p-px-5"
        @click="isShowSupplier = false"
      >
        {{ __("Back") }}
      </p-vue-button> -->
    </div>
  </i-override-dialog>
  <p-get-image v-if="getImage" @getImage="getPictureLocal"></p-get-image>
</template>

<script>
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import LocalAllServices from "./all-services";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
import LocalSupplier from "@/views/v-suppliers/";
import { getPicture } from "../../services/UploadFilesService";
import PGetImage from "@/components/partials/p-get-image";
import { UploadServiceCallImageUrl } from "../../services/cloudflareUploaderService";

export default {
  components: {
    LocalAllServices,
    LocalSupplier,
    PGetImage,
  },
  props: {
    serviceCall: Object,
    close: Function,
    fastAdd: Boolean,
    PID: {
      type: Number,
      default: 0,
    },
  },
  emits: ["serviceCallChanged"],
  data() {
    return {
      showGroups: false,
      serviceCallLocal: {},
      SuppliersOptions: [],
      PriorityOptions: [],
      WorkersOptions: [],
      ReportTypesOptions: [],
      GroupsOptions: [],
      UnitsOptions: [],
      BuildingsOptions: [],
      errors: { Subject: null, addContact: null, BID: null },
      valid: true,
      showAddContactDropdowns: false,
      isTreatment: false,
      smsSentToSupplier: false,
      addDetailsOfCustomersToSmsSupplier: false,
      contentSMSToSupplier: null,
      showContentSms: false,
      isEditSmsContent: false,
      isShowSupplier: false,
      attachments: [],
      getImage: false,
      filesSentCnt: 0,
      filesUploadSuccessCnt: 0,
      newServiceCall: null,
    };
  },
  mounted() {
    if (this.PID != 0) {
      this.getServiceCallData();
    } else {
      this.serviceCallLocal = this.serviceCall ? this.serviceCall : {};
      if (this.$route.params.bid)
        this.serviceCallLocal.BID = +this.$route.params.bid;
      this.getData();
    }
    // console.log(this.serviceCallLocal);
    if (!this.isEdit && !this.fastAdd) this.showGroups = true;
  },
  methods: {
    getData() {
      let bid = this.serviceCallLocal.BID ? this.serviceCallLocal.BID : 0;
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("BID", bid, apiPType.Int),
      ];
      callProc("WorkerApp_DropDownDataToProblem", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.ReportTypesOptions = result.Table;
          this.PriorityOptions = result.Table1;
          this.WorkersOptions = result.Table2;
          this.SuppliersOptions = result.Table3;
          this.GroupsOptions = result.Table4;
          this.UnitsOptions = result.Table5;
          this.BuildingsOptions = result.Table6;

          if (result.Table7[0].AddDetailsOfCustomersToSmsSupplier != 0)
            this.addDetailsOfCustomersToSmsSupplier = true;
          else this.addDetailsOfCustomersToSmsSupplier = false;
          if (result.Table7[0].SendSMSToSupplier_OpenProblem != 0)
            this.smsSentToSupplier = true;
          else this.smsSentToSupplier = false;

          if (this.BuildingsOptions.length == 1) {
            this.serviceCallLocal.BID = this.BuildingsOptions[0].BID;
            this.buildingChanged();
          }

          if (this.isEdit) {
            this.serviceCallLocal.ReportTypeValue = this.ReportTypesOptions.find(
              (f) => f.Num == this.serviceCallLocal.ReportType
            );
            this.serviceCallLocal.ReportPriorityValue = this.PriorityOptions.find(
              (f) => f.Num == this.serviceCallLocal.ReportPriority
            );
            this.serviceCallLocal.SupplierNumValue = this.SuppliersOptions.find(
              (f) => f.pid == this.serviceCallLocal.SupplierNum
            );
            this.serviceCallLocal.mtcGroupIDValue = this.GroupsOptions.find(
              (f) => f.GroupID == this.serviceCallLocal.mtcGroupID
            );
            this.serviceCallLocal.UIDValue = this.UnitsOptions.find(
              (f) => f.UID == this.serviceCallLocal.UID
            );
            if (this.serviceCallLocal.ClosingDate)
              this.serviceCallLocal.ClosingDate = new Date(
                this.serviceCallLocal.ClosingDate
              );
          }
          if (this.fastAdd || this.isEdit) {
            if (this.serviceCallLocal.DueDate)
              this.serviceCallLocal.DueDate = new Date(
                this.serviceCallLocal.DueDate
              );
          }

          if (!this.serviceCallLocal?.WorkerNum && !this.isEdit)
            this.serviceCallLocal.WorkerNum = this.userNum;
          this.serviceCallLocal.WorkerNumValue = this.WorkersOptions.find(
            (f) => f.Num == this.serviceCallLocal.WorkerNum
          );
          this.serviceCallLocal.BIDValue = this.BuildingsOptions.find(
            (f) => f.BID == this.serviceCallLocal.BID
          );
          this.$store.dispatch("doLoading", false);
        })
        .catch((e) => {
          errorReceived("WorkerApp_DropDownDataToProblem", e);
        });
    },
    groupSelected(groupId) {
      this.showGroups = false;
      this.serviceCallLocal.mtcGroupIDValue = this.GroupsOptions.find(
        (f) => f.GroupID == groupId
      );
    },
    GetUnitsAndContactsToBuildings() {
      let procParams = [
        apiParam("BID", this.serviceCallLocal.BIDValue.BID, apiPType.Int),
      ];
      callProc("WorkerApp_GetUnitsAndContactsToBuildings", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.UnitsOptions = result.Table;
          this.UnitsOptions.map((unit) => {
            unit.contacts = result.Table1.filter((f) => f.UID == unit.UID);
          });
          this.serviceCallLocal.UIDValue = null;
          this.serviceCallLocal.Contact = null;
          this.serviceCallLocal.ReturnPhone = null;
          this.serviceCallLocal.ReportName = null;
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived(
            "WorkerApp_GetUnitsAndContactsToBuildings",
            __("An error occurred")
          );
        });
    },
    addContact() {
      if (!this.serviceCallLocal.BIDValue?.BID) {
        this.errors.addContact =
          "A reporter cannot be added if a building is not selected";
        return;
      }
      this.GetUnitsAndContactsToBuildings();
      this.showAddContactDropdowns = true;
    },
    buildingChanged() {
      if (this.showAddContactDropdowns) {
        this.GetUnitsAndContactsToBuildings();
      }
      this.errors.addContact = null;
    },
    changeReporter() {
      this.serviceCallLocal.ReturnPhone = this.serviceCallLocal.Contact.TelMobile;
      this.serviceCallLocal.ReportName = this.serviceCallLocal.Contact.ContactName;
    },
    isTreatmentChange() {
      if (this.isTreatment) this.serviceCallLocal.ClosingDate = new Date();
      else this.serviceCallLocal.ClosingDate = null;
    },
    showSupplier() {
      this.isShowSupplier = true;
    },
    editSms() {
      this.getContentSMSToSupplier();
    },
    lockAllFields() {
      this.isEditSmsContent = true;
    },
    getContentSMSToSupplier() {
      if (this.serviceCallLocal.BIDValue?.BID) {
        const procParams = [
          apiParam("BID", this.serviceCallLocal.BIDValue?.BID, apiPType.Int),
          apiParam("Desc", this.serviceCallLocal.Desc, apiPType.NVarChar),
          apiParam("Subject", this.serviceCallLocal.Subject, apiPType.NVarChar),
          apiParam(
            "ReportName",
            this.serviceCallLocal.ReportName,
            apiPType.NVarChar
          ),
          apiParam(
            "ReturnPhone",
            this.serviceCallLocal.ReturnPhone,
            apiPType.NVarChar
          ),
          apiParam(
            "AddDetailsOfCustomerToSmsSupplier",
            this.addDetailsOfCustomersToSmsSupplier,
            apiPType.Bit
          ),
          apiParam("UserID", this.userNum, apiPType.Int),
        ];
        callProc("WorkerApp_ContentSMSToSupplierFromProblem", procParams)
          .then((result) => {
            result = JSON.parse(result);
            this.contentSMSToSupplier = result.Table[0].Content;
            this.showContentSms = true;
          })
          .catch(() => {
            errorReceived("WorkerApp_ContentSMSToSupplierFromProblem");
          });
      }
    },
    changeSmsSentToSupplier() {
      this.contentSMSToSupplier = null;
      this.isEditSmsContent = false;
      this.showContentSms = false;
    },
    validateFields() {
      this.valid = true;
      this.errors.Subject = null;
      this.errors.BID = null;
      if (!this.serviceCallLocal.Subject) {
        this.valid = false;
        this.errors.Subject = "Required field";
      }
      if (!this.serviceCallLocal.BIDValue?.BID) {
        this.valid = false;
        this.errors.BID = "Required field";
      }
    },
    save() {
      this.validateFields();
      if (!this.valid) return;
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("PID", this.serviceCallLocal.PID, apiPType.Int),
        apiParam(
          "ReportType",
          this.serviceCallLocal.ReportTypeValue?.Num,
          apiPType.TinyInt
        ),
        apiParam(
          "MtcGroupID",
          this.serviceCallLocal.mtcGroupIDValue?.GroupID,
          apiPType.Int
        ),
        apiParam(
          "ReportPriority",
          this.serviceCallLocal.ReportPriorityValue?.Num,
          apiPType.TinyInt
        ),
        apiParam("Email", this.serviceCallLocal.ReturnEmail, apiPType.NVarChar),
        apiParam("Subject", this.serviceCallLocal.Subject, apiPType.NVarChar),
        apiParam("Desc", this.serviceCallLocal.Desc, apiPType.NVarChar),
        apiParam(
          "ReturnPhone",
          this.serviceCallLocal.ReturnPhone,
          apiPType.NVarChar
        ),
        apiParam(
          "DueDate",
          this.serviceCallLocal.DueDate,
          apiPType.SmallDateTime
        ),
        apiParam(
          "ClosingDate",
          this.serviceCallLocal.ClosingDate,
          apiPType.SmallDateTime
        ),
        apiParam(
          "WorkerNum",
          this.serviceCallLocal.WorkerNumValue?.Num,
          apiPType.Int
        ),
        apiParam(
          "SupplierNum",
          this.serviceCallLocal.SupplierNumValue?.pid,
          apiPType.Int
        ),
        apiParam("BID", this.serviceCallLocal.BIDValue?.BID, apiPType.Int),
        apiParam("UID", this.serviceCallLocal.UIDValue?.UID, apiPType.Int),
        apiParam(
          "ReportName",
          this.serviceCallLocal.ReportName,
          apiPType.NVarChar
        ),
        apiParam("SmsSentToSupplier", this.smsSentToSupplier, apiPType.Bit),
        apiParam(
          "ContentSMSToSupplier",
          this.contentSMSToSupplier,
          apiPType.NVarChar
        ),
      ];
      callProc("WorkerApp_UpdateOrInsertProblem", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          if (result.procReturnValue == 0) {
            this.newServiceCall = result.Table[0];
            this.filesSentCnt = 0;
            this.filesUploadSuccessCnt = 0;
            if (this.attachments && this.attachments.length > 0)
              this.sendFiles();
            else this.success();
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch((err) => {
          console.log(err);
          errorReceived("WorkerApp_UpdateOrInsertProblem");
        });
    },
    cancel() {
      if (this.$route.name == "AddServiceCalls")
        this.$router.push({ name: "Dashboard" });
      else this.close();
    },
    addImage() {
      this.getImage = false;
      setTimeout(() => {
        this.getImage = true;
      }, 0);
    },
    getPictureLocal(sourceType) {
      getPicture(sourceType, (obj) => {
        this.getImage = false;
        this.attachments.push(obj);
      });
    },
    doTrashAttachment(index) {
      this.attachments.splice(index, 1);
    },
    sendFiles() {
      this.attachments.forEach((element, idx) => {
        let procParams = [
          apiParam("PID", this.newServiceCall.PID, apiPType.Int),
          apiParam("FileEXT", "JPEG", apiPType.NVarChar),
          apiParam(
            "Subject",
            this.newServiceCall.Subject.substring(0, 50) +
              " " +
              (idx + 1) +
              ".jpeg",
            apiPType.NVarChar
          ),
          apiParam("createBy", this.userNum, apiPType.Int),
        ];
        callProc("TennatApp_CreateNewFile", procParams)
          .then((result) => {
            result = JSON.parse(result);
            this.upload(
              element,
              result.Table[0].ImgID,
              this.newServiceCall.Subject.substring(0, 50) +
                " " +
                (idx + 1) +
                ".jpeg"
            );
          })
          .catch((error) => {
            errorReceived(
              "TennatApp_CreateNewFile",
              error,
              __("An error occurred")
            );
          });
      });
    },
    upload(file, FileId, srcFileName, isFirst = true) {
      this.filesSentCnt++;
      // console.log(-1, -1, -1, srcFileName, file, -1, -FileId);
      UploadServiceCallImageUrl(FileId, file, srcFileName)
        .then((response) => {
          // console.log("UploadServiceCallImageUrl", response);
          this.$store.dispatch("doLoading", false);
          // console.log(response);
          if (response === true) this.filesUploadSuccessCnt++;
          else {
            this.deleteImageRowFromTable(
              FileId,
              `ERROR : error from server file_len: ${file.length}`
            );
          }
          if (
            this.filesSentCnt == this.filesUploadSuccessCnt &&
            this.filesUploadSuccessCnt == this.attachments.length
          ) {
            this.success();
          } else if (this.filesSentCnt == this.attachments.length) {
            this.$store.dispatch("doLoading", false);

            this.$emit("serviceCallChanged", this.newServiceCall);
          }
        })
        .catch((e) => {
          if (isFirst && e?.message == "Failed to fetch") {
            setTimeout(() => {
              this.upload(file, FileId, srcFileName, false);
            }, this.filesSentCnt * 1000);
          } else {
            console.log(e);
            this.uploadProgress = 0;
            this.deleteImageRowFromTable(
              FileId,
              `ERROR : ${e?.message} file_len: ${file.length}`
            );
            this.success();
          }
        });
    },
    success() {
      showSuccessOrFailedModal(__("The service call was saved successfully"));
      setTimeout(() => {
        if (this.$route.name == "AddServiceCalls") {
          this.$router.push({ name: "Dashboard" });
        }
        this.$emit("serviceCallChanged", this.newServiceCall);
      }, 2000);
    },
    deleteImageRowFromTable(fileId, e) {
      let procParams = [
        apiParam("fileId", fileId, apiPType.Int),
        apiParam("error", e, apiPType.NVarChar),
      ];
      callProc("TennatApp_DeleteServiceCallImage", procParams)
        .then((result) => {
          result = JSON.parse(result);
          console.log(result);
        })
        .catch((error) => {
          errorReceived(
            "TennatApp_DeleteServiceCallImage",
            error,
            __("An error occurred")
          );
        });
    },
    UnitSelected() {
      this.serviceCallLocal.Contact = this.serviceCallLocal.UIDValue?.contacts[0];
    },
    getServiceCallData() {
      // 	EXEC dbo.WorkerApp_ListProblems @UserNum = @UserNum, @BID = null, @Status = 0,
      // @TypeFilter = 1,
      // @Rules = 1, @HomeSvcCalls = null, @PID=@PID, @ReportType = 0
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("BID", null, apiPType.Int),
        apiParam("Status", 0, apiPType.TinyInt),
        apiParam("TypeFilter", 1, apiPType.TinyInt),
        apiParam("Rules", true, apiPType.Bit),
        apiParam("HomeSvcCalls", null, apiPType.Bit),
        apiParam("PID", this.PID, apiPType.NVarChar),
        apiParam("ReportType", 0, apiPType.TinyInt),
      ];
      callProc("WorkerApp_ListProblems", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.Table[0]) {
            this.serviceCallLocal = result.Table[0];
            this.showGroups = false;
            if (this.serviceCallLocal.DueDate)
              this.serviceCallLocal.DueDate = new Date(
                this.serviceCallLocal.DueDate
              );

            this.getData();
          }
        })
        .catch((error) => {
          errorReceived(
            "WorkerApp_ListProblems",
            error,
            __("An error occurred")
          );
        });
    },
  },
  computed: {
    isEdit() {
      return this.serviceCall?.PID || this.PID != 0 ? true : false;
    },
    buildingSelected() {
      return this.serviceCallLocal.BIDValue;
    },
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
  watch: {
    smsSentToSupplier() {
      if (this.smsSentToSupplier) this.getContentSMSToSupplier();
    },
    buildingSelected() {
      this.getContentSMSToSupplier();
    },
  },
};
</script>

<style scoped>
.p-inputtextarea {
  width: 100%;
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
}

.grid.supplier {
  grid-template-columns: 86% 12%;
}

.add-contact {
  width: 100%;
  border-radius: 4px;
  margin-bottom: 2px;
}

.he .show-supplier {
  transform: rotate(270deg);
}

.upload-button {
  margin-top: 25px;
  display: block;
  width: 100%;
  margin: 0;
  padding: 13px 15px;
  border-radius: 30px;
  background-color: white;
  border: 1px solid var(--color-success);
  color: black;
  font-size: 16px;
  line-height: 1.28;
  letter-spacing: 0.51px;
  text-align: center;
}

.upload-button:deep(.p-button) {
  display: block;

  width: 100%;

  margin: 0;
  padding: 13px 15px;

  border-radius: 30px;
  background-color: white;
  border: 1px solid var(--color-success);

  color: black;
  font-size: 16px;
  line-height: 1.28;
  letter-spacing: 0.51px;
}

.upload-preview ul {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

  margin: 0;
  padding: 15px 0 0 0;

  list-style: none;
}

.upload-preview ul li {
  position: relative;
}

.upload-preview ul li img {
  width: 100%;
  height: 100%;

  object-fit: cover;
}

.upload-preview ul li:deep(.svg) {
  width: 15px;
  height: 15px;
}

.upload-preview ul li:deep(.p-button) {
  top: -5px;
  left: -5px;
  z-index: 2;
  position: absolute;

  padding: 3px;
}
</style>
